<template>
  <div>
    <DataTableWrapper
      ref="tableWrapper"
      :initialSortBy="initialSortBy"
      :data-source="{
        type: 'AxisGQL',
        query: require('@/services/gql/types/Hotels/queries/hotelsGrid.gql')
      }"
      :headers="$options.headersConfig"
      :filters="{
        id: { control: 'text', modifier: 'contains' },
        title: { control: 'text', modifier: 'contains' },
        slug: { control: 'text', modifier: 'contains' },
        status: {
          control: 'select',
          options: [...$options.statusList],
          dataType: String
        },
        createdAt: { control: 'date-range' },
        updatedAt: { control: 'date-range' },
        translations: {
          control: 'select',
          options: [
            {
              value: 'ru',
              text: 'ru'
            },
            {
              value: 'en',
              text: 'en'
            },
            {
              value: 'ja',
              text: 'ja'
            },
            {
              value: 'zh',
              text: 'zh'
            },
            {
              value: 'ko',
              text: 'ko'
            }
          ]
        }
      }"
      @query-state-updated="getStateQuery"
      :stored-headers="getCurrentViewCols"
      :views-list="getViewList"
      :active-view-key="getActiveViewKey"
      :views-loading="$async.updateMe.$pending"
      @view-changed="updateStoredView"
      @active-view-changed="updateStoredActiveView"
      @remove-view="removeStoredView"
      @data-loaded="onTableDataChange"
    >
      <template v-slot="{ tableProps, tableListeners, filtersProps, filtersListeners }">
<!--          show-select-->
        <v-data-table
          fixed-header
          height="80vh"
          :items-per-page="$options.perPage.itemsPerPage"
          :footer-props="{ itemsPerPageOptions: $options.perPage.itemsPerPageOptions }"
          v-bind="tableProps"
          v-on="tableListeners"
          v-model="mixSelectedItems"
          @update:sort-by="updateSortBy"
          @update:sort-desc="sortDesc = $event"
        >
          <template v-for="(h, i) in $options.headersConfig" v-slot:[`header.${h.value}`]>
            <v-tooltip open-delay="350" :key="i" bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ h.text }}</span>
              </template>
              <span>{{ h.description }}</span>
            </v-tooltip>
          </template>
          <template v-slot:[`body.prepend`]="{}">
            <DataTableFilters
              is-grid-selectable
              v-bind="filtersProps"
              v-on="filtersListeners"
            />
          </template>
          <template
            v-for="(h, i) in $options.headersConfig"
            v-slot:[`item.${h.value}`]="{ item }"
          >
            <div :key="i">
              <div v-if="h.type === 'number' && item[h.value] !== null">
                {{ formatAmount(item[h.value]) }}
              </div>
              <div v-else-if="h.text === 'Заголовок'">
                <router-link
                  title="Редактировать"
                  :to="{
                    name: 'page-hotel',
                    params: {
                      id: item.id
                    }
                  }"
                  >{{ item[h.value] }}</router-link
                >
              </div>
              <div v-else-if="h.type === 'date'">
                <DateTimeCell :value="item[h.value]" />
              </div>
              <div v-else-if="h.type === 'boolean'">
                <v-icon
                  v-text="'mdi-checkbox-marked-circle'"
                  :color="item[h.value] ? 'success' : 'grey'"
                />
              </div>
              <div v-else-if="h.type === 'actions'">
                <router-link
                  :to="{
                    name: 'page-hotel',
                    params: {
                      id: item.id
                    }
                  }"
                  title="Редактировать"
                  ><v-btn icon><v-icon>mdi-pencil</v-icon></v-btn></router-link
                >
                <a title="Удалить">
                  <v-btn icon @click="deleteHotel(item.id)">
                    <v-icon color="red">mdi-trash-can-outline</v-icon>
                  </v-btn>
                </a>
              </div>
              <div v-else-if="h.value === 'translations'">{{ getLanguage(item) }}</div>
              <div v-else-if="h.value === 'status'">{{ mixGetStatus(item) }}</div>
              <div v-else>
                {{ get(item, h.value) }}
              </div>
            </div>
          </template>
        </v-data-table>
      </template>
    </DataTableWrapper>
    <ConfirmationDialog ref="confirmHotelRemoving" confirmText="Удалить" />
  </div>
</template>

<script>
import { gridDependentMixin } from '@/pages/grid-dependent.mix'
import { formatAmount, get } from '@/utils'
import perPage from '@/configs/v-data-table.js'
import headersConfig from './headersConfig.js'
import DataTableWrapper from '@/components/data-table-wrapper'
import DataTableFilters from '@/components/data-table-filters'
import DateTimeCell from '@/components/date-time-cell'
import { paramsToListQueryInput } from '@/components/data-table-wrapper/data-sources/axis-gql/utils'
import ConfirmationDialog from '@/components/confirmation-dialog'
import deleteHotelMutation from '@/services/gql/types/Hotels/mutations/deleteHotel.gql'
import updateMeMutation from '@/services/gql/types/Me/mutations/updateMe.gql'

export default {
  name: 'GridHotels',
  gridType: 'hotels',
  perPage,
  headersConfig,
  props: {
    category: {
      type: Object,
      default: null
    }
  },
  mixins: [gridDependentMixin],
  components: {
    DataTableWrapper,
    DataTableFilters,
    DateTimeCell,
    ConfirmationDialog
  },
  data () {
    return {
      queryState: null,
      sortDesc: false,
      initialSortBy: []
    }
  },
  methods: {
    get,
    refetch () {
      this.$refs.tableWrapper.refresh()
    },
    formatAmount,
    getStateQuery (state) {
      this.queryState = paramsToListQueryInput(state)
    },
    async deleteHotel (hotelId) {
      try {
        await this.$refs.confirmHotelRemoving.open()
        await this.$async.deleteHotel.$perform({ id: hotelId })
        this.$successMsg('Отель удален')
        this.refetch()
      } catch (e) {
        if (e.cancel) return
        this.$handleApiError(
          e.graphQLErrors,
          `Ошибка при удалении события с ID ${hotelId}`
        )
      }
    },
    updateSortBy ([field]) {
      this.$set(this.initialSortBy, 0, {
        field,
        dir: this.sortDesc[0] ? 'desc' : 'asc'
      })
      this.refetch()
    }
  },
  async: {
    deleteHotel (variables) {
      return this.$apollo.mutate({
        mutation: deleteHotelMutation,
        variables
      })
    },
    updateMe (variables) {
      return this.$apollo.mutate({
        mutation: updateMeMutation,
        variables
      })
    }
  }
}
</script>
